import { AlbumDetails as AlbumDetailsModule } from "../modules/AlbumDetails/AlbumDetails";

const AlbumDetails = () => {
  return <AlbumDetailsModule />;
};

export default AlbumDetails;
